import { FontWeight } from '@leland-dev/leland-ui-library';
import { type FC, type ReactNode } from 'react';

import { type InputOption } from '../forms/Inputs';

import RadioInput from './RadioInput';

export interface RadioToggleOption extends InputOption {
  rightContent?: ReactNode;
}

interface RadioToggleProps {
  options: RadioToggleOption[];
  value: string | number | null;
  onChange: (value: string | number) => void;
  name: string;
  labelFontWeight?: Extract<FontWeight, FontWeight.MEDIUM | FontWeight.NORMAL>;
}

export const RadioToggle: FC<RadioToggleProps> = ({
  options,
  value,
  onChange,
  name,
  labelFontWeight = FontWeight.NORMAL,
}) => {
  return (
    <div className="divide-y divide-leland-gray-stroke rounded-md border border-leland-gray-stroke">
      {options.map((option) => (
        <div key={option.value} className="p-4">
          <RadioInput
            className="mr-4"
            labelClassName={`items-center text-leland-gray-alt w-full ${labelFontWeight === FontWeight.MEDIUM ? 'font-medium' : ''}`}
            option={{
              ...option,
              label: (
                <div className="flex w-full items-center justify-between py-1 leading-5">
                  <div className="text-leland-gray-dark">{option.label}</div>
                  {option.rightContent}
                </div>
              ),
            }}
            onChange={() => onChange(option.value)}
            name={name}
            checked={value === option.value}
          />
        </div>
      ))}
    </div>
  );
};
